import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import cfac22 from 'js/library/utils/cfac22';
import createGuest from 'js/library/utils/API/createGuest';
import { getPartnerUserForms } from 'js/library/utils/API/getPartnerUserForms';

const Context = createContext(null);
const fieldsOf = (form) => (Array.isArray(form?.formFields) ? form.formFields : []);
const indexKeyOf = (form) => {
  const found = fieldsOf(form).filter((f) => f?.indexKey === true);
  return found.length === 1 ? found[0] : null;
};
export function PartnerUserFormsProvider({ children }) {
  const partnerId = cfac22('partnerId');
  const [state, setState] = useState({ loading: true, error: null, form: null });
  const load = useCallback(async () => {
    setState({ loading: true, error: null, form: null });
    try {
      const guest = await createGuest();
      if (!guest) throw new Error('Não foi possível iniciar a sessão convidada.');
      const form = await getPartnerUserForms(partnerId);
      if (!indexKeyOf(form)) throw new Error('O formulário não possui um indexKey válido.');
      setState({ loading: false, error: null, form });
    } catch (error) {
      setState({
        loading: false,
        error: error?.message || 'Não foi possível carregar o formulário.',
        form: null,
      });
    }
  }, [partnerId]);
  useEffect(() => {
    load();
  }, [load]);
  const value = useMemo(
    () => ({ ...state, partnerId, indexKey: indexKeyOf(state.form), reload: load }),
    [state, partnerId, load]
  );
  // Keep the provider mounted while the form loads. Rendering a loading/error
  // screen here replaces the entire application, although this state belongs
  // only to the authentication form container.
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const usePartnerUserForms = () => {
  const value = useContext(Context);
  if (!value) throw new Error('usePartnerUserForms fora do provider');
  return value;
};
